<template>
  <gl-popup v-slot="{ close }" :class-modifier="['mini', 'withTopPadding']" @close="$emit('close')">
    <gl-msg-result icon-name="error" :title="title" :text="text">
      <template #btn>
        <gl-button variant="gray" size="lg" class="popupBtnClose" @click="close">
          Close
        </gl-button>
      </template>
    </gl-msg-result>
  </gl-popup>
</template>

<script>
import GlPopup from '@gl/GlPopup'
import GlMsgResult from '@gl/GlMsgResult'
import GlButton from '@gl/GlButton'

export default {
  name: 'HeaderSearchPopup',
  components: { GlButton, GlMsgResult, GlPopup },
  props: {
    title: {
      type: String,
      default: 'Oops',
    },
    text: {
      type: String,
      default: "We couldn't find what you are looking for.",
    },
  },
  emits: ['close'],
}
</script>

<style lang="scss" scoped>
.popupBtnClose {
  width: 100%;
}
</style>
